module.exports = __webpack_public_path__ + "static/3f3a20cea58b2432364758571f17132080d9b33a6b017d54143248d482914da6-92a2232a2b18d71fca286ea7842a65f4.jpeg";